import { FC, useState } from 'react';

import Stepper from 'components/Stepper';
import { StepOptions } from 'components/Stepper/types';

import SaveClientAlert from '../components/SaveClientAlert';
import { createEmptyClientContact } from '../hooks/useClientFormModalContext';
import CreateClientContactForm from './ClientContactForm';
import CreateClientForm from './ClientForm';
import { OrganizationFormFlowContext } from './hooks/useOrganizationFormFlowContext';

/**
 * Form to create or edit a client organization
 */
const OrganizationForm: FC = () => {
  const [selectedContact, setSelectedContact] = useState(
    createEmptyClientContact(),
  );

  const steps: StepOptions[] = [
    {
      key: 'client-organization-form',
      render: (props) => <CreateClientForm {...props} />,
    },
    {
      key: 'client-contact-form',
      render: (props) => <CreateClientContactForm {...props} />,
    },
    {
      key: 'client-save-changes-alert',
      render: () => <SaveClientAlert />,
    },
  ];
  return (
    <OrganizationFormFlowContext.Provider
      value={{ selectedContact, setSelectedContact }}
    >
      <Stepper steps={steps} />
    </OrganizationFormFlowContext.Provider>
  );
};

export default OrganizationForm;
